import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { Card, CardBody } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import style from "./style.module.css";
import { ICON_NAMES } from "utils/constant";
import { CustomRowRender } from "ui/grid/CustomGrid";
import { TextButton } from "ui/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import { Invoice } from "interface/accounting";
import { InvoiceGridColumnItem } from "component/pages/invoice/GridColumns";
import { lastColWithBtn } from "ui/grid/lastColumnts";
import { getInvoicesApi } from "api/accounting";
import { addMonths } from "date-fns";
import { PdfType } from "utils/PdfType";
import { useUserOrganizationsStore } from "store";
import { GrideDateFormatter } from "ui/Date";

function InvoiceCard({
	isMobileView = false,
}: {
	isMobileView?: boolean;
	buyerLedgerAccountNumber?: string;
}) {
	const [gridData, setGridData] = useState<Invoice[]>([]);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const { defaultOrg } = useUserOrganizationsStore();

	useEffect(() => {
		getInvoicesApi({
			buyerLedgerAccountNumber: defaultOrg?.ledgerAccountNumber as any,
			take: 3,
			skip: 0,
			fromDate: null,
			toDate: null,
		})
			.then((response) => {
				setGridData(response.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [defaultOrg]);

	const openPdfByRow = (prop: GridCellProps) => {
		window.open(`/${PageTypePath.Pdf}/${prop.dataItem.reportGuid}`, "_blank");
	};
	return (
		<div>
			<Card
				//className={style.CardItem}
				className={"home-card-item"}
			>
				<CardBody>
					<div className={`${styles.BoxHeadingMedium} ${style.CardBodyHeader}`}>
						<div>{t("LastInvoices")}</div>
						<div>
							<TextButton
								text={t("OverviewInvoices")}
								onClick={() => navigate(`/${PageTypePath.SalesNotesList}`)}
								iconName={ICON_NAMES.Arrow}
							/>
						</div>
					</div>
					<div>
						{isMobileView ? (
							<div>
								{gridData.map((item, index) => {
									const isOverdue =
										item.dueDate &&
										new Date(item.dueDate).getTime() < new Date().getTime() &&
										(item.remainingValue || 0) !== 0;

									return (
										<div
											key={`${item.invoiceNumber}-${index}`}
											className="home-mobile-list-item"
										>
											<div className="home-mobile-list-item-main">
												<div className="home-mobile-list-item-value">
													{item.invoiceType} {item.invoiceNumber}
												</div>
												<div className="home-mobile-list-item-label">
													<GrideDateFormatter
														date={item.invoiceDate}
														formatType="dd.MM.yyyy"
														noTd={true}
													/>
												</div>
											</div>
											<div
												className="home-mobile-list-item-secondary"
												style={{ color: isOverdue ? "#d64545" : undefined }}
											>
												{item.remainingValue || 0} kr
											</div>
											<div className="home-mobile-list-item-actions">
												<button
													type="button"
													className="home-mobile-icon-btn"
													onClick={() =>
														openPdfByRow({ dataItem: item } as GridCellProps)
													}
												>
													<img
														src={`/icon/${ICON_NAMES.Download}.svg`}
														alt={t("Download")}
													/>
												</button>
											</div>
										</div>
									);
								})}
							</div>
						) : (
							<Grid
								style={{ height: "auto" }}
								rowHeight={38}
								rows={{ data: (row) => CustomRowRender(row) }}
								data={gridData}
								className={
									styles.tableColgroupColFirstChild + " custom_detail_grid"
								}
							>
								{InvoiceGridColumnItem().map((column, key) => (
									<GridColumn key={key} {...column} className="no-border" />
								))}
								<GridColumn
									{...lastColWithBtn({
										width: "60px",
										showDetails: false,
										items: [
											{
												iconName: ICON_NAMES.Download,
												onclick: openPdfByRow,
												alwaysShow: true,
											},
										],
										showDelete: false,
									})}
								/>
							</Grid>
						)}
					</div>
				</CardBody>
			</Card>
		</div>
	);
}

export default InvoiceCard;
